import FormValidator from './FormValidator';
import { ValidateOfferCode, ValidateNoneZero, ValidatePhoneNumberOptional, ValidateAccountPassword, ValidateInput, ValidateAddressInput, ValidateEmployerInput, ValidateDate, ValidatePhoneNumber, ValidateBirthdate, ValidateEmailAddress, ValidateProvince, ValidatePostalCode, ValidateAddress, ValidateMailingAddress} from './Validation';
import moment from 'moment';

export function PersonalInfoValidator() {
  return new FormValidator([
    { 
      field: 'firstName', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, first name is required' 
    },
    { 
      field: 'firstName', 
      method: ValidateInput,         
      validWhen: true, 
      message: 'Oops, first name contains invalid characters.' 
    },
    { 
      field: 'firstName', 
      method: 'isLength', 
      args: [{min:0, max: 35}],
      validWhen: true, 
      message: 'Oops, first name is too long, Please shorten to 35 characters.' 
    },
    //  PBI 456177: VOA - Restriction to cardholder name fields; Changed Middle Name to Middle Initial
    { 
      field: 'middleName', 
      method: 'isLength', 
      args: [{min:0, max: 1}],
      validWhen: true, 
      message: 'Oops, middle initial is too long, Please shorten to 1 character.' 
    },
    { 
      field: 'middleName', 
      method: ValidateInput,         
      validWhen: true, 
      message: 'Oops, middle name contains invalid characters.' 
    },      
    { 
      field: 'lastName', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, last name is required' 
    },
    { 
      field: 'lastName', 
      method: ValidateInput,         
      validWhen: true, 
      message: 'Oops, last name contains invalid characters.' 
    },
    { 
      field: 'lastName', 
      method: 'isLength', 
      args: [{min:0, max: 35}],
      validWhen: true, 
      message: 'Oops, last name is too long, Please shorten to 35 characters.' 
    },
    { 
      field: 'birthdate', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, birthdate is required'
    },    
    { 
      field: 'birthdate', 
      method: ValidateBirthdate,
      validWhen: true, 
      message: 'Oops, this is not a valid date.'
    },
    { 
      field: 'birthdate', 
      method: 'isBefore',
      args: [moment().subtract(19, 'years').format()],
      validWhen: true, 
      message: 'Sorry, you must be at least 19 to apply for a Vancity credit card.'
    },
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    { 
      field: 'mobilePhone', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, mobile phone is required.' 
    }, 
    { 
      field: 'mobilePhone', 
      method: ValidatePhoneNumber, 
      validWhen: true, 
      message: 'Oops, mobile phone number is not valid.' 
    },
    { 
      field: 'homePhone', 
      method: ValidatePhoneNumberOptional, 
      validWhen: true, 
      message: 'Oops, home phone number is not valid.' 
    },
    { 
      field: 'email', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, email is required.' 
    },  
    { 
      field: 'email', 
      method: ValidateEmailAddress, 
      validWhen: true, 
      message:  'Oops, email doesn’t look right.' 
    },  
    { 
      field: 'email', 
      method: 'isLength', 
      args: [{min:0, max: 50}],
      validWhen: true, 
      message: 'Oops, email is too long, Please shorten to 50 characters.' 
    },
    { 
      field: 'accountPassword', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, verification password is required.' 
    },
    { 
      field: 'accountPassword', 
      method: ValidateAccountPassword, 
      validWhen: true, 
      message:  'Oops, verification password doesn’t look right.' 
    },  
    { 
      field: 'accountPassword', 
      method: 'isLength', 
      args: [{min:0, max: 15}],
      validWhen: true, 
      message: 'Oops, verification password is too long, Please shorten to 15 characters.' 
    },
    { 
      field: 'housingStatus', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, housing status is required'
    },   
    { 
      field: 'moveInDate', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, move in date is required'
    },  
    { 
      field: 'moveInDate', 
      method: ValidateDate,
      validWhen: true, 
      message: 'Oops, this is not a valid date.'
    }
  ]);
}    

export function IncomeExpensesValidator() {
  return new FormValidator([
    { 
      field: 'income', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, average personal monthly income is required' 
    },
    { 
      field: 'rent', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, rent or mortgage is required' 
    },
    { 
      field: 'loans', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, loans or lines of credit required' 
    },
    { 
      field: 'creditcards', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, credit cards is required' 
    }
  ]);
}

export function IncomeFinancesValidator() {
  return new FormValidator([
    {
      field: 'householdincome',
      method: 'isEmpty',
      validWhen: false,
      message: 'Oops, annual household income is required'
    },
    {
      field: 'investmentincome',
      method: 'isEmpty',
      validWhen: false,
      message: 'Oops, investable funds amount is required'
    }    
  ]);
}

export function AddressValidator() {
  return new FormValidator([
    { 
      field: 'address1', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, address line 1 is required.' 
    },
    { 
      field: 'address1', 
      method: ValidateAddress, 
      validWhen: false, 
      message: 'Oops, home address cannot be a PO Box or general delivery address.' 
    },    
    { 
      field: 'address1', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, address line 1 contains invalid characters.' 
    },   
    {
      field: 'address2', 
      method: 'isLength', 
      args: [{min:0, max: 35}],
      validWhen: true, 
      message: 'Oops, address line 2 is too long, Please shorten to 35 characters.' 
    },
    { 
      field: 'address2', 
      method: ValidateAddress, 
      validWhen: false, 
      message: 'Oops, home address cannot be a PO Box or general delivery address.' 
    },     
    { 
      field: 'address2', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, address line 2 contains invalid characters.' 
    },     
    { 
      field: 'province', 
      method: ValidateProvince, 
      validWhen: true, 
      message: 'Oops, you must be a resident of British Columbia to apply for a Vancity Visa card.' 
    },
    { 
      field: 'city', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, city is required.' 
    },
    { 
      field: 'city', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, city contains invalid characters.' 
    },  
    {
      field: 'postalCode', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, postal code is required.' 
    },    
    { 
      field: 'postalCode', 
      method: ValidatePostalCode, 
      validWhen: true, 
      message: 'Oops, postal code is not valid.' 
    } 
  ]);
}

export function MailingAddressValidator() {
  return new FormValidator([
    { 
      field: 'address1', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, address line 1 is required.' 
    },
    { 
      field: 'address1', 
      method: ValidateMailingAddress, 
      validWhen: false, 
      message: 'Oops, mailing address cannot be a general delivery address.' 
    },     
    { 
      field: 'address1', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, address line 1 contains invalid characters.' 
    },   
    { 
      field: 'address2', 
      method: 'isLength', 
      args: [{min:0, max: 35}],
      validWhen: true, 
      message: 'Oops, address line 2 is too long, Please shorten to 35 characters.' 
    },
    { 
      field: 'address2', 
      method: ValidateMailingAddress, 
      validWhen: false, 
      message: 'Oops, mailing address cannot be a general delivery address.' 
    },     
    { 
      field: 'address2', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, address line 2 contains invalid characters.' 
    },     
    { 
      field: 'province', 
      method: ValidateProvince, 
      validWhen: true, 
      message: 'Oops, you must be a resident of British Columbia to apply for a Vancity Visa card.' 
    } ,
    { 
      field: 'city', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, city is required.' 
    },
    { 
      field: 'city', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, city contains invalid characters.' 
    },  
    { 
      field: 'postalCode', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, postal code is required.' 
    },    
    { 
      field: 'postalCode', 
      method: ValidatePostalCode, 
      validWhen: true, 
      message: 'Oops, postal code is not valid.' 
    } 
  ]);
}

export function OccupationValidator(status) {
  return new FormValidator([
    { 
      field: 'industry', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, industry is required' 
    },
    { 
      field: 'occupationName', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, occupation is required' 
    },
    { 
      field: 'employer', 
      method: 'isEmpty', 
      validWhen: false, 
      args: [{fieldName: status === "Employed" ? "employer" : "company name"}],
      message: 'Oops, <fieldName> is required' 
    },
    { 
      field: 'employer', 
      method: 'isLength', 
      args: [{min:0, max: 1, fieldName: status === "Employed" ? "employer" : "company name" }],
      validWhen: false, 
      message: 'Oops, <fieldName> is too short, Please enter at least 2 characters.' 
    },
    { 
      field: 'employer', 
      method: 'isLength', 
      args: [{min:2, max: 35, fieldName: status === "Employed" ? "employer" : "company name" }],
      validWhen: true, 
      message: 'Oops, <fieldName> is too long, Please shorten to 35 characters.' 
    }, 
    { 
      field: 'employer', 
      method: ValidateEmployerInput,         
      validWhen: true, 
      args: [{fieldName: status === "Employed" ? "employer" : "company name"}],
      message: 'Oops, <fieldName> contains invalid characters.' 
    },  
    { 
      field: 'employedSince', 
      method: 'isEmpty', 
      validWhen: false, 
      args: [{fieldName: status === "Employed" ? "employer" : "company name"}],
      //Bug 452975: Error message incorrect. Typo corrected
      message: 'Oops, employed since is required' 
    },
    { 
      field: 'employedSince', 
      method: ValidateDate,
      validWhen: true, 
      message: 'Oops, this is not a valid date.'
    },
    { 
      field: 'phone', 
      method: ValidatePhoneNumberOptional, 
      validWhen: true, 
      message: 'Oops, phone number is not valid.' 
    }
  ]);
}

export function AuthUserValidator() {
  return new FormValidator([
    { 
      field: 'firstName', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, first name is required' 
    },
    { 
      field: 'firstName', 
      method: ValidateInput,         
      validWhen: true, 
      message: 'Oops, first name contains invalid characters.' 
    },
    { 
      field: 'lastName', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, last name is required' 
    },
    { 
      field: 'lastName', 
      method: ValidateInput,         
      validWhen: true, 
      message: 'Oops, last name contains invalid characters.' 
    },
    { 
      field: 'birthdate', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, birthdate is required'
    },    
    { 
      field: 'birthdate', 
      method: ValidateBirthdate,
      validWhen: true, 
      message: 'Oops, this is not a valid date.'
    },
    { 
      field: 'birthdate', 
      method: 'isBefore',
      args: [moment().subtract(12, 'years').format()],
      validWhen: true, 
      message: 'Sorry, but an authorized user must be at least 12 years old to receive a credit card.'
    },
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    { 
      field: 'mobilePhone', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, mobile phone is required.' 
    }, 
    { 
      field: 'mobilePhone', 
      method: ValidatePhoneNumber, 
      validWhen: true, 
      message: 'Oops, mobile phone number is not valid.' 
    },
    { 
      field: 'homePhone', 
      method: ValidatePhoneNumberOptional, 
      validWhen: true, 
      message: 'Oops, home phone number is not valid.' 
    },
    // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
    { 
      field: 'email', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, email is required.' 
    },  
    { 
      field: 'email', 
      method: ValidateEmailAddress, 
      validWhen: true, 
      message:  'Oops, email doesn’t look right.' 
    },  
    { 
      field: 'email', 
      method: 'isLength', 
      args: [{min:0, max: 50}],
      validWhen: true, 
      message: 'Oops, email is too long, Please shorten to 50 characters.' 
    }, 
    { 
      field: 'address1', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, address line 1 is required.' 
    },
    { 
      field: 'address1', 
      method: ValidateAddress, 
      validWhen: false, 
      message: 'Oops, home address cannot be a PO Box or general delivery address.' 
    },          
    { 
      field: 'address1', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, address line 1 contains invalid characters.' 
    },   
    { 
      field: 'address2', 
      method: 'isLength', 
      args: [{min:0, max: 35}],
      validWhen: true, 
      message: 'Oops, address line 2 is too long, Please shorten to 35 characters.' 
    },
    { 
      field: 'address2', 
      method: ValidateAddress, 
      validWhen: false, 
      message: 'Oops, home address cannot be a PO Box or general delivery address.' 
    },         
    { 
      field: 'address2', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, address line 2 contains invalid characters.' 
    },      
    { 
      field: 'province', 
      method: ValidateProvince, 
      validWhen: true, 
      message: 'Oops, you must be a resident of British Columbia to apply for a Vancity Visa card.' 
    },
    { 
      field: 'city', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, city is required.' 
    },  
    { 
      field: 'city', 
      method: ValidateAddressInput,         
      validWhen: true, 
      message: 'Oops, city contains invalid characters.' 
    },   
    { 
      field: 'postalCode', 
      method: 'isEmpty', 
      validWhen: false, 
      message: 'Oops, postal code is required.' 
    },    
    { 
      field: 'postalCode', 
      method: ValidatePostalCode, 
      validWhen: true, 
      message: 'Oops, postal code is not valid.' 
    }
  ]);
}

export function OfferCodeValidator() {
  return new FormValidator([
    {
      field: 'offerCode',
      method: ValidateOfferCode,
      validWhen: true,
      message: 'Oops, offer code is not valid.'
    } 
  ]);
}

export function BpiValidator() {
  return new FormValidator([
    {
      field: 'bpi',
      method: 'isEmpty',
      validWhen: true,
      message: 'Oops, we need to know whether you&apos;d like to add balance protection insurance'
    } 
  ]);
}


// WEBPACK FOOTER //
// ./src/utils/Validators.js